<div class="tab-pane" role="tabpanel" id="Constructora">
    <fieldset id="agregar_constructora" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Informaci&oacute;n de la Constructora</strong></h3>
            <hr />
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar Constructora</p>
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="rut_emp" class="col-md-1" style="padding-top: 15px">RUT</label>
                            <div class="col-md-2">
                                <form [formGroup]="rut_consta">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Rut" id="rut_consta" name="rut_consta" formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_consta && rut_consta.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>

                                    </mat-form-field>
                                </form>
                            </div>
                            <div class="col-md-2">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_consta" [disabled]="!rut_consta.valid" (click)="get_Constructora(rut_consta.controls.rut.value)">
                                    Agregar Constructora
                                <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                            </button>
                            </div>
                        </div>
                    </div>
                    <br />
                    <!--Detalle de los constructoras-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE CONSTRUCTORA</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>

                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>

                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_constructora(row.rut,rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_Constructora(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>

                </div>

            </div>
        </div>
    </fieldset>
    <!-- Modal -->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de la constructora</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del Constructor</strong>, su solicitud pasar&aacute; por un proceso de verificaci&oacute;n del constructor ingresado. <br>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rut">RUT(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md" [(ngModel)]="constructora.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group" >
                    <label class="col-md-4 control-label" for="nombre_consta">Raz&oacute;n Social(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="nombre_consta" name="nombre_consta" type="text" placeholder="Raz&oacute;n Social" [(ngModel)]="constructora.nombre" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div hidden="hidden">
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="dir_calle_consta">Direcci&oacute;n: Calle(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_calle_consta" name="dir_calle_consta" type="text" placeholder="Calle" [(ngModel)]="constructora.direccion" class="form-control input-md">
                        </div>
                        <label class="col-md-2 control-label" for="dir_num_consta">Direcci&oacute;n: Numero(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_num_consta" name="dir_num_consta" type="text" placeholder="Numero" [(ngModel)]="constructora.direccion_num" class="form-control input-md">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="comuna">Comuna(<span style="color: red">*</span>) </label>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width">
                                <input type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput [formControl]="nombreComuna" [matAutocomplete]="auto" [(ngModel)]="constructora.comuna">
                                <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                    {{option}}
                                </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div class="form-group">

                    <label class="col-md-4 control-label" for="dir_completa_consta">Direcci&oacute;n: Completa</label>
                    <div class="col-md-6">
                        <input id="dir_completa_consta" name="dir_completa_consta" type="text" placeholder="Direccion completa" [(ngModel)]="constructora.direccion_completa" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>

                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fono_consta">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono_consta" name="fono_consta" type="text" placeholder="Tel&eacute;fono" [(ngModel)]="constructora.fono" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="email_consta">Email(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="email_consta" name="email_consta" type="email" placeholder="mail@ejemplo.com" [(ngModel)]="constructora.mail" class="form-control input-md">
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_consta" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_consta" (click)="saveConstructora() " [disabled]="!constructora.rut || !constructora.nombre || !constructora.mail">Ingresar constructora <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>
<div class="separator"></div>